import { RestApiRequest } from '../rest';
import { ActionContext, Store } from 'vuex';
import '@nuxtjs/axios';
import type { CatalogDataResponse } from '~/types/catalog';
import { IRootState } from '~/types/store/root';

type actionState = ActionContext<null, IRootState>;

export async function Full(this: Store<any>, store: actionState, params) {

    const response = await RestApiRequest<CatalogDataResponse>({
        name: 'discontCatalog',
        params,
    }, store, this.$axios);

    return response.data;
}

export async function Page(this: Store<any>, store: actionState, params) {

    const response = await RestApiRequest<CatalogDataResponse>({
        name: 'discontCatalogPage',
        params,
    }, store, this.$axios);

    if (response.status === 200) {
        return response.data;
    } else {
        throw Error('some error');
    }
}
